import { graphql } from 'gatsby'
import React from 'react'
import loadable from '@loadable/component'
import Layout from '../components/Layout'
import Header from '../components/services/Header'

const InEngineAnimation = loadable(() => import('../components/services/InEngineAnimation'))
const MotionCapture = loadable(() => import('../components/services/MotionCapture'))
const CreativeService = loadable(() => import('../components/services/CreativeService'))
const PreRenderedAnimation = loadable(() => import('../components/services/PreRenderedAnimation'))
const VirtualitySection = loadable(() => import('../components/services/VirtualitySection'))

const ServiceIndex = ({data: {page}}) => {
    return (
            <Layout meta={page.frontmatter.meta || false}>
                <Header data={page.frontmatter}/>
                <CreativeService data={page.frontmatter.creativeServicesSection}/>
                <InEngineAnimation data={page.frontmatter.inEngineAnimationSection}/>
                <PreRenderedAnimation data={page.frontmatter.preRenderedAnimationSection}/>
                <MotionCapture data={page.frontmatter.motionCaptureSection}/>
                <VirtualitySection data={page.frontmatter.virtualRealitySection} contactDescription={page.frontmatter.getInTouchSectionDescription} contactImage={page.frontmatter.getInTouchSectionImage}/>
            </Layout>
    )
}

export default ServiceIndex

export const pageQuery = graphql`
    query ServiceIndex($id: String !) {
        page: markdownRemark(id: {eq: $id}) {
            ...Meta
            html
            id
            frontmatter {
                title
                subtitle
                bannerDescription
                bannerImages {
                    image
                    alt
                }
                creativeServicesSection {
                    title
                    description
                    image
                }
                preRenderedAnimationSection {
                    title
                    description
                    image
                }  
                inEngineAnimationSection {
                    title
                    description
                    image
                }       
                motionCaptureSection {
                    title
                    description
                    sliderImages {
                        image
                        alt
                    }
                }
                virtualRealitySection {
                    title
                    description
                    desktopImage
                    mobileImage
                }
                getInTouchSectionDescription
                getInTouchSectionImage
            }
        }
    }
`